import React, { useCallback, useEffect, useState, lazy, memo } from 'react';
// Extract data to constants outside the component to reduce re-parsing
const FIRST_NAMES = ['John', 'Emma', 'Michael', 'Olivia', 'William', 'Ava', 'James', 'Sophia', 'Robert', 'Isabella', 'David', 'Mia', 'Joseph', 'Charlotte', 'Thomas', 'Amelia', 'Charles', 'Harper', 'Daniel', 'Evelyn', 'Matthew', 'Abigail', 'Anthony', 'Emily', 'Mark', 'Elizabeth', 'Donald', 'Sofia', 'Steven', 'Avery', 'Paul', 'Ella'];
const LAST_NAMES = ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Martinez', 'Hernandez', 'Lopez', 'Gonzalez', 'Wilson', 'Anderson', 'Thomas', 'Taylor', 'Moore', 'Jackson', 'Martin', 'Lee', 'Perez', 'Thompson', 'White', 'Harris', 'Sanchez', 'Clark', 'Ramirez', 'Lewis', 'Robinson', 'Walker', 'Young'];
const STATES = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
// Use memo to prevent unnecessary re-renders
const SalesPopup = memo(() => {
  const [visible, setVisible] = useState(false);
  const [currentFirstName, setCurrentFirstName] = useState('');
  const [currentLastName, setCurrentLastName] = useState('');
  const [currentState, setCurrentState] = useState('');
  const [isPhysicalCopy, setIsPhysicalCopy] = useState(true);
  const [isPremiumHardcover, setPremiumHardcover] = useState(false);
  // Memoize the generate person function
  const generatePerson = useCallback(() => {
    const randomFirstName = FIRST_NAMES[Math.floor(Math.random() * FIRST_NAMES.length)];
    const randomLastName = LAST_NAMES[Math.floor(Math.random() * LAST_NAMES.length)];
    const randomState = STATES[Math.floor(Math.random() * STATES.length)];
    // Determine product type with new probabilities
    // 35% Premium Hardcover, 50% Physical Copy, 15% Digital Copy
    const random = Math.random();
    const isPremiumHardcover = random < 0.35;
    const isPhysicalCopy = random >= 0.35 && random < 0.85;
    setCurrentFirstName(randomFirstName);
    setCurrentLastName(randomLastName);
    setCurrentState(randomState);
    setIsPhysicalCopy(isPhysicalCopy);
    setPremiumHardcover(isPremiumHardcover);
  }, []);
  // Memoize the cycle function
  const startCycle = useCallback(() => {
    // Generate new person details
    generatePerson();
    setVisible(true);
    // Hide popup after 3 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
      // After 3 seconds of being hidden, start cycle again
      const showTimer = setTimeout(() => {
        startCycle();
      }, 3000);
      return () => clearTimeout(showTimer);
    }, 3000);
    return () => clearTimeout(hideTimer);
  }, [generatePerson]);
  useEffect(() => {
    // Delay initial popup to improve page load performance
    const initialDelay = setTimeout(() => {
      startCycle();
    }, 2000);
    return () => clearTimeout(initialDelay);
  }, [startCycle]);
  // Determine the price based on product type
  const getPrice = () => {
    if (isPremiumHardcover) return '94.97';
    if (isPhysicalCopy) return '49.97';
    return '19.97';
  };
  return <div className={`fixed left-1/2 bottom-4 -translate-x-1/2 z-50 w-full max-w-[90%] md:max-w-[400px] bg-white border border-gray-200 rounded-md shadow-md overflow-hidden transition-all duration-500 ease-in-out ${visible ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform translate-y-10 pointer-events-none'}`} data-id="element-220">
      <div className="flex items-center p-2" data-id="element-221">
        <div className="w-10 h-10 flex-shrink-0 mr-3" data-id="element-222">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/inq4dLe15a2qVGibMXnZAc/Charlie_kirk_book_cover.png" alt="Remembering Charlie Kirk Book" className="w-full h-full object-cover rounded-sm" width="40" height="40" loading="lazy" data-id="element-223" />
        </div>
        <div className="flex-grow" data-id="element-224">
          <h3 className="text-gray-800 font-medium text-sm flex items-center" data-id="element-225">
            <span data-id="element-226">
              {currentFirstName} {currentLastName}
            </span>
            <span className="mx-1 text-xs text-gray-400" data-id="element-227">•</span>
            <span className="text-xs font-normal text-gray-500" data-id="element-228">
              {currentState}
            </span>
          </h3>
          <p className="text-gray-600 text-xs" data-id="element-229">Purchase made: ${getPrice()}</p>
          <p className="text-gray-600 text-xs italic" data-id="element-230">
            Remembering Charlie Kirk
          </p>
        </div>
        <div className="text-right text-gray-500 text-xs whitespace-nowrap ml-2" data-id="element-231">
          Just now
        </div>
      </div>
    </div>;
});
// Add display name for better debugging
SalesPopup.displayName = 'SalesPopup';
export { SalesPopup };
export default SalesPopup;